import { render, staticRenderFns } from "./MerchantPoints.vue?vue&type=template&id=e6916f10&"
import script from "./MerchantPoints.vue?vue&type=script&lang=js&"
export * from "./MerchantPoints.vue?vue&type=script&lang=js&"
import style0 from "./MerchantPoints.vue?vue&type=style&index=0&id=e6916f10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports